import styled, { css } from 'styled-components';

export const WatchCardContainer = styled.div<{ $unavailable?: boolean }>`
  min-width: 300px;
  flex-shrink: 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }

  ${(p) =>
    p.$unavailable &&
    css`
      filter: grayscale(0.85);
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      }
    `}
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

export const WatchImage = styled.img<{ $unavailable?: boolean }>`
  width: 100%;
  height: 300px;
  object-fit: cover;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  transition: transform 0.3s ease;
  opacity: ${(p) => (p.$unavailable ? 0.55 : 1)};

  ${WatchCardContainer}:hover & {
    transform: scale(${(p) => (p.$unavailable ? 1 : 1.05)});
  }
`;

export const StatusBadge = styled.div<{ $variant: 'sold' | 'reserved' }>`
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 14px;
  font-family: 'Abel', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #fff;
  border-radius: 2px;
  z-index: 2;
  ${(p) =>
    p.$variant === 'sold'
      ? css`
          background: rgba(33, 33, 33, 0.92);
          font-weight: 600;
        `
      : css`
          background: rgba(184, 150, 74, 0.92);
        `}
`;

export const WatchInfo = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
`;

export const WatchBrand = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.main};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  letter-spacing: 1px;
`;

export const WatchModel = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.main};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const WatchPrice = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.accent};
`;
